import * as types from "./types";

export const getCompanyEventRequestsRequest = (payload) => ({
  type: types.GET_COMPANY_EVENT_REQUESTS_REQUEST,
  payload,
});

export const getCompanyEventRequestsResponse = (payload) => ({
  type: types.GET_COMPANY_EVENT_REQUESTS_RESPONSE,
  payload,
});

export const getCompanyEventRequestsSummaryResponse = (payload) => ({
  type: types.GET_COMPANY_EVENT_REQUESTS_SUMMARY_RESPONSE,
  payload,
});

export const bulkApproveCompanyEventRequestsRequest = (payload) => ({
  type: types.BULK_APPROVE_COMPANY_EVENT_REQUESTS_REQUEST,
  payload,
});

export const bulkRejectCompanyEventRequestsRequest = (payload) => ({
  type: types.BULK_REJECT_COMPANY_EVENT_REQUESTS_REQUEST,
  payload,
});

export const bulkAllocateCompanyEventRequestsRequest = (payload) => ({
  type: types.BULK_ALLOCATE_COMPANY_EVENT_REQUESTS_REQUEST,
  payload,
});

export const bulkUnassignCompanyEventRequestsRequest = (payload) => ({
  type: types.BULK_UNASSIGN_COMPANY_EVENT_REQUESTS_REQUEST,
  payload,
});

export const bulkRemoveCompanyEventRequestsRequest = (payload) => ({
  type: types.BULK_REMOVE_COMPANY_EVENT_REQUESTS_REQUEST,
  payload,
});

export const bulkChangeRoleCompanyEventRequestsRequest = (payload) => ({
  type: types.BULK_CHANGE_ROLE_COMPANY_EVENT_REQUESTS_REQUEST,
  payload,
});
